import { required, email, min } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'

setInteractionMode('eager')

extend('required', {
  ...required,
  message: '{_field_} no puede ser vacío',
})

extend('min', {
  ...min,
  message: '{_field_} no puede ser menor que {length} caracteres',
})

extend('email', {
  ...email,
  message: 'Correo Electrónico debe ser válido',
})

export default {
  components: {
    ValidationObserver,
    ValidationProvider
  },
}
